<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <v-row no-gutters>
      <!-- ==================== حالت ۱: پترن تکی ==================== -->
      <v-col v-if="!isCampaign" class="d-flex flex-column flex-md-row pa-2 align-stretch" cols="12">
        <!-- باکس پیش‌نمایش پترن تکی -->
        <div
          class="col-md-5 rounded-lg pa-4 mx-auto mb-4 mb-md-0 d-flex flex-column"
          style="background: #f1f5f9; border: 1px solid #e2e8f0;"
        >
          <div class="text-caption font-weight-bold grey--text text--darken-2 mb-2">
            پیام:
          </div>
          <div
            v-if="message && message.content"
            class="msg-preview-box pa-3 rounded-lg flex-grow-1"
            v-html="singlePreviewText"
          ></div>
          <div v-else class="text-center grey--text pt-4">
            الگوی پیام انتخاب نشده
          </div>
        </div>

        <!-- باکس ورودی‌های پترن تکی -->
        <div
          class="col-md pa-4 mr-md-2 rounded-lg"
          style="background: #f8fafc; border: 1px solid #e2e8f0;"
        >
          <div class="text-caption font-weight-bold grey--text text--darken-2 mb-3">
            ورودی‌های اجباری پیام:
          </div>

          <div v-for="key in patternKeys" :key="key" class="mb-3">
            <!-- ورودی دستی -->
            <v-text-field
              v-if="computedValue[key] && computedValue[key].state === 'data'"
              v-model="computedValue[key].text"
              :label="key"
              dense
              outlined
              hide-details
              class="bg-white"
            >
              <template v-slot:append-outer>
                <input-generate-menu v-model="computedValue[key].state" />
              </template>
            </v-text-field>

            <!-- ورودی از مشخصات کاربر -->
            <v-autocomplete
              v-else-if="computedValue[key]"
              v-model="computedValue[key].text"
              :items="userInfoItems"
              item-text="text"
              item-value="value"
              :label="key"
              :readonly="readonly"
              dense
              outlined
              hide-details
              class="bg-white"
            >
              <template v-slot:append-outer>
                <input-generate-menu v-model="computedValue[key].state" />
              </template>
            </v-autocomplete>
          </div>

          <div v-if="patternKeys.length === 0" class="text-center grey--text text-caption py-4">
            این الگو داینامیکی ندارد.
          </div>
        </div>
      </v-col>

      <!-- ==================== حالت ۲: کمپین چند پیامی ==================== -->
      <v-col
        v-else-if="isCampaign && campaignMessages && campaignMessages.length"
        class="pa-2"
        cols="12"
      >
        <!-- هدر کمپین -->
        <div class="text-center mb-4">
          <span class="grey--text text--darken-2 font-weight-bold">کمپین انتخاب شده:</span>
          <span class="primary--text font-weight-bold text-subtitle-1 mx-1">{{ campaignName }}</span>
          <span class="grey--text text-caption">({{ campaignMessages.length }} پیام)</span>
        </div>

        <!-- کارت‌های پیام‌های کمپین -->
        <div class="d-flex flex-column align-center" style="gap: 20px">
          <div
            v-for="(text, i) in campaignMessages"
            :key="i"
            class="campaign-item-card rounded-xl pa-4"
            style="width: 100%; max-width: 760px; background: #eaedf1;"
          >
            <!-- بج شماره پیام -->
            <v-avatar
              class="campaign-badge white--text font-weight-bold elevation-2"
              color="#00b074"
              size="32"
            >
              {{ i + 1 }}
            </v-avatar>

            <v-row no-gutters class="align-stretch">
              <!-- بخش پیش‌نمایش متن پیام (ارتفاع کامل) -->
              <v-col
                :cols="getMessageKeys(text).length > 0 ? 12 : 12"
                :md="getMessageKeys(text).length > 0 ? 6 : 12"
                class="pa-1 d-flex flex-column"
              >
                <div
                  class="msg-preview-box pa-3 rounded-lg flex-grow-1"
                  v-html="getCampaignMessagePreview(text, i)"
                ></div>
              </v-col>

              <!-- بخش فیلدهای ورودی متغیرهای پیام -->
              <v-col
                v-if="getMessageKeys(text).length > 0"
                cols="12"
                md="6"
                class="pa-1 d-flex flex-column"
              >
                <div class="campaign-inputs-box pa-3 rounded-lg flex-grow-1">
                  <div class="text-caption font-weight-bold grey--text text--darken-3 mb-2">
                    ورودی‌های پیام {{ i + 1 }}:
                  </div>
                  <div
                    v-for="key in getMessageKeys(text)"
                    :key="key"
                    class="mb-2"
                  >
                    <!-- ورودی دستی کمپین -->
                    <v-text-field
                      v-if="computedValue[i] && computedValue[i][key] && computedValue[i][key].state === 'data'"
                      v-model="computedValue[i][key].text"
                      :label="key"
                      dense
                      outlined
                      hide-details
                      class="bg-white"
                    >
                      <template v-slot:append-outer>
                        <input-generate-menu v-model="computedValue[i][key].state" />
                      </template>
                    </v-text-field>

                    <!-- ورودی از مشخصات مخاطب -->
                    <v-autocomplete
                      v-else-if="computedValue[i] && computedValue[i][key]"
                      v-model="computedValue[i][key].text"
                      :items="userInfoItems"
                      item-text="text"
                      item-value="value"
                      :label="key"
                      :readonly="readonly"
                      dense
                      outlined
                      hide-details
                      class="bg-white"
                    >
                      <template v-slot:append-outer>
                        <input-generate-menu v-model="computedValue[i][key].state" />
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- زمان ارسال (Gap) در پایین کارت -->
            <div class="text-center mt-3 d-flex align-center justify-center">
              <v-icon x-small color="grey darken-1" class="me-1">mdi-clock-outline</v-icon>
              <span class="text-caption font-weight-bold grey--text text--darken-2">
                {{ formatGap(campaignGaps[i], campaignTypes[i]) }}
              </span>
            </div>
          </div>
        </div>
      </v-col>

      <!-- پیام عدم وجود کمپین فعال -->
      <v-col v-else-if="isCampaign" class="pa-12 text-center">
        <v-icon x-large color="grey lighten-1">mdi-message-bulleted-off</v-icon>
        <p class="mt-4 grey--text text-subtitle-1">این کمپین پیام فعالی ندارد</p>
      </v-col>
    </v-row>
  </help-info-wrapper>
</template>

<script>
import InputGenerateMenu from "@/view/components/fragments/inputGenerateMenu.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";

export default {
  name: "patternInputsGenerate",
  components: { InputGenerateMenu, HelpInfoWrapper },

  props: {
    value: { type: Object, default: () => ({}) },
    isCampaign: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    message: {
      type: Object,
      default: () => ({
        content: "",
        messages: { name: "", text: [], gap: [], type: [], count: 0 },
      }),
    },
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "patterninputsGenerate",
    userInfoItems: [
      { value: "preName", text: "پیشوند" },
      { value: "name", text: "نام" },
      { value: "middleName", text: "نام میانی" },
      { value: "lastName", text: "نام خانوادگی" },
      { value: "postName", text: "پسوند" },
      { value: "alias", text: "نام مستعار" },
      { value: "companyName", text: "شرکت" },
      { value: "jobTitle", text: "عنوان شغلی" },
      { value: "phone", text: "شماره تلفن" },
      { value: "birthday", text: "تاریخ تولد" },
      { value: "description", text: "توضیحات" },
      { value: "discount", text: "کد تخفیف" },
    ],
  }),

  computed: {
    computedValue: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    singlePreviewText() {
      if (!this.message || !this.message.content) return "";
      let text = (this.message.content || "").trim();

      this.patternKeys.forEach((key) => {
        const valObj = this.computedValue ? this.computedValue[key] : null;
        let displayVal = valObj ? valObj.text : null;

        const replacement = displayVal
          ? `<span class="colored">${displayVal}</span>`
          : `<span class="colored">${key}</span>`;

        text = text.replace(new RegExp(`\\b${key}\\b`, "g"), replacement);
      });

      return text;
    },

    campaignName() {
      return (
        (this.value && this.value.name) ||
        (this.message && this.message.messages && this.message.messages.name) ||
        "کمپین بدون نام"
      );
    },

    campaignMessages() {
      return (
        (this.value && this.value.text) ||
        (this.message && this.message.messages && this.message.messages.text) ||
        []
      );
    },

    campaignGaps() {
      return (
        (this.value && this.value.gap) ||
        (this.message && this.message.messages && this.message.messages.gap) ||
        []
      );
    },

    campaignTypes() {
      return (
        (this.value && this.value.type) ||
        (this.message && this.message.messages && this.message.messages.type) ||
        []
      );
    },

    patternKeys() {
      if (this.isCampaign) return [];

      let content = (this.message && this.message.content) || "";
      if (!content && this.value && Object.keys(this.value).length > 0) {
        const keys = Object.keys(this.value).filter((k) => /^data\d+$/.test(k));
        if (keys.length > 0) {
          content = keys.join(" ");
        }
      }

      const matches = content.match(/data\d+/g) || [];
      return [...new Set(matches)];
    },
  },

  methods: {
    getMessageKeys(text) {
      if (!text) return [];
      const matches = text.match(/data\d+/g) || [];
      return [...new Set(matches)];
    },

    getCampaignMessagePreview(text, index) {
      if (!text) return "";
      let formattedText = (text || "").trim();
      const keys = this.getMessageKeys(formattedText);

      keys.forEach((key) => {
        let displayVal = null;
        if (this.computedValue && this.computedValue[index] && this.computedValue[index][key]) {
          const valObj = this.computedValue[index][key];
          displayVal = valObj.text;
        }

        const replacement = displayVal
          ? `<span class="colored">${displayVal}</span>`
          : `<span class="colored">${key}</span>`;

        formattedText = formattedText.replace(new RegExp(`\\b${key}\\b`, "g"), replacement);
      });

      return formattedText;
    },

    formatGap(gap, type = "hour") {
      if (gap === 0 || gap === "0" || gap === undefined || gap === null) return "ارسال فوری";
      const num = parseInt(gap);
      if (isNaN(num)) return "ارسال فوری";
      return `${num} ${type === "hour" ? "ساعت" : "روز"} بعد`;
    },

    initFields() {
      const newValue = { ...(this.value || {}) };
      let changed = false;

      if (!this.isCampaign) {
        this.patternKeys.forEach((key) => {
          if (!newValue[key]) {
            this.$set(newValue, key, { state: "userInfo", text: "name" });
            changed = true;
          }
        });
      } else {
        this.campaignMessages.forEach((text, i) => {
          const keys = this.getMessageKeys(text);
          if (!newValue[i]) {
            this.$set(newValue, i, {});
            changed = true;
          }
          keys.forEach((key) => {
            if (!newValue[i][key]) {
              this.$set(newValue[i], key, { state: "userInfo", text: "name" });
              changed = true;
            }
          });
        });
      }

      if (changed) {
        this.computedValue = newValue;
      }
    },
  },

  watch: {
    message: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => this.initFields());
      },
    },
    isCampaign() {
      this.$nextTick(() => this.initFields());
    },
  },

  mounted() {
    this.initFields();
  },
};
</script>

<style scoped>
.campaign-item-card {
  position: relative;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #d1d5db;
}

.campaign-badge {
  position: absolute;
  top: -12px;
  right: 16px;
  z-index: 2;
}

.msg-preview-box {
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 0.93rem;
  line-height: 1.9;
  white-space: pre-wrap;
  word-break: break-word;
  direction: rtl;
  color: #1e293b;
  border: 1px solid rgba(0, 0, 0, 0.08);
  height: 100% !important;
  min-height: 100% !important;
}

.campaign-inputs-box {
  background-color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.bg-white {
  background-color: #ffffff !important;
}

::v-deep .colored {
  background-color: rgba(195, 99, 4, 0.65) !important;
  color: #ffffff !important;
  padding: 3px 8px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  display: inline-block !important;
  line-height: 1.5 !important;
  font-size: 0.85rem !important;
}
</style>
